import React from "react";

const Error = () => {
  return (
    <div className="p-10">
      <h1 className="text-4xl text-center font-bold tracking-wider capitalize">
        Something Went Wrong! Please Check Correct URL To Visit the Page.
      </h1>
    </div>
  );
};

export default Error;
